export default defineNuxtRouteMiddleware(async to => {
  const { $um } = useNuxtApp()

  const user = await $um.getUser()
  if (!user) {
    $um.signinRedirect()
    return abortNavigation('Redirecting to login...')
  }

  const roles = user.profile.roles as string[]
  if (
    !roles.some(
      r => r == (to.meta.role || 'nonexistentrole') || r == 'Super User',
    )
  ) {
    return abortNavigation('Not Authorized')
  }
})
